// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-section[data-v-423fcfb0] {
  height: 65px;
  display: grid;
  grid-template-columns: repeat(var(--btn-columns), 1fr);
}
.footer-section .sec-btn[data-v-423fcfb0] {
  margin: auto;
  padding: 6px 12px;
  -webkit-app-region: no-drag;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNew/videoConfSectionFooter.vue"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sDAAsD;AACxD;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B","sourcesContent":[".footer-section[data-v-423fcfb0] {\n  height: 65px;\n  display: grid;\n  grid-template-columns: repeat(var(--btn-columns), 1fr);\n}\n.footer-section .sec-btn[data-v-423fcfb0] {\n  margin: auto;\n  padding: 6px 12px;\n  -webkit-app-region: no-drag;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
